var app = angular.module("leonardo");

var DateFilter = function($scope, $rootScope, $attrs, $filter, FilterService) {
  
  $scope.filter = $attrs.filter;
  $scope.last_month = FilterService.getFilter('last_month');
  $scope.date_from = FilterService.getFilter($scope.filter + '__gte');
  $scope.date_to = FilterService.getFilter($scope.filter + '__lte');

  $scope.initFilter = function(filter) {
    $scope.filter = filter;
    $scope.last_month = FilterService.getFilter('last_month');
    $scope.date_from = FilterService.getFilter($scope.filter + '__gte');
    $scope.date_to = FilterService.getFilter($scope.filter + '__lte');
    
    if($scope.last_month){
      $scope.date_from = '';
      $scope.date_to = '';
      $scope.updateLastMonth();
    }
  };

  $scope.setLastMonth = function () {
    if ($scope.last_month){
      $scope.last_month = false;
      FilterService.removeFilter('last_month');
    }
    else {
      $scope.last_month = true;
      $scope.date_from = '';
      $scope.date_to = '';
      $scope.updateLastMonth();
    }
  };

  $scope.updateLastMonth = function() {
    var from = moment().date(1).subtract(1, 'months').format('YYYY-MM-DD');
    var to = moment().date(0).format('YYYY-MM-DD');
    FilterService.setFilter('last_month', $scope.last_month);
    FilterService.setFilter($scope.filter + '__gte', from);
    FilterService.setFilter($scope.filter + '__lte', to);
  };

  $scope.$watch('date_from', function(newValue) {
    if (newValue !== undefined && newValue !== null && newValue !== '')
      $scope.last_month = false;
    FilterService.setFilter($scope.filter + '__gte', newValue);
  });

  $scope.$watch('date_to', function(newValue) {
    if (newValue !== undefined && newValue !== null && newValue !== '')
      $scope.last_month = false;
    FilterService.setFilter($scope.filter + '__lte', newValue);
  });

  if($scope.last_month){
    $scope.date_from = '';
    $scope.date_to = '';
    $scope.updateLastMonth();
  }
};

app.controller('DateFilter', ['$scope', '$rootScope', '$attrs', '$filter', 'FilterService', DateFilter]);
